import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import type { PageParams, SortParam } from './types';

type State = PageParams & { sort?: SortParam };

export function useTableState(tableId: string, defaultPageSize = 25) {
  const [params, setParams] = useSearchParams();
  const ns = `${tableId}.`;

  const page = Number(params.get(`${ns}page`) ?? 1);
  const pageSize = Number(params.get(`${ns}pageSize`) ?? defaultPageSize);
  const sortField = params.get(`${ns}sortField`);
  const sortOrder = params.get(`${ns}sortOrder`) as 'ascend' | 'descend' | null;
  const sort: SortParam =
    sortField && sortOrder ? { field: sortField, order: sortOrder } : undefined;

  const setState = useCallback(
    (next: Partial<State>) => {
      const updated = new URLSearchParams(params);
      if (next.page !== undefined) updated.set(`${ns}page`, String(next.page));
      if (next.pageSize !== undefined) updated.set(`${ns}pageSize`, String(next.pageSize));
      if (next.sort !== undefined) {
        if (next.sort) {
          updated.set(`${ns}sortField`, next.sort.field);
          updated.set(`${ns}sortOrder`, next.sort.order);
        } else {
          updated.delete(`${ns}sortField`);
          updated.delete(`${ns}sortOrder`);
        }
      }
      setParams(updated, { replace: true });
    },
    [params, setParams, ns],
  );

  return { page, pageSize, sort, setState };
}
